//External dependencies
import { CardStyleInterpolators, createStackNavigator } from '@react-navigation/stack';
import { SCREEN_NAMES } from '../../constants';
import { THEME_COLORS } from '../../theme/constants/themeColors';
import SavedChargingStationsScreen from '../../ui/components/SavedChargingStationsScreen';
import ChargePointQRScannerScreen from '../../ui/screens/ChargePointQRScannerScreen';
import ChargingHistoryFiltersScreen from '../../ui/screens/ChargingHistoryFiltersScreen';
import ChargingHistoryScreen from '../../ui/screens/ChargingHistoryScreen';
import ChargingProcessScreen from '../../ui/screens/ChargingProcessScreen';
import ChargingStartingSoonScreen from '../../ui/screens/ChargingStartingSoonScreen';
import ChargingStatesScreen from '../../ui/screens/ChargingStatesScreen';
import ChargingStationDetailScreen from '../../ui/screens/ChargingStationDetailScreen';
import ChargingSuccessfulScreen from '../../ui/screens/ChargingSuccessfulScreen';
import EditProfileScreen from '../../ui/screens/EditProfileScreen';
import EnterAccessCodeScreen from '../../ui/screens/EnterAccessCodeScreen';
import EnterChargePointIdScreen from '../../ui/screens/EnterChargePointIdScreen';
import EnterFleetCodeScreen from '../../ui/screens/EnterFleetCodeScreen';
import FiltersScreen from '../../ui/screens/FilterScreen/FiltersScreen';
import MapScreen from '../../ui/screens/MapScreen';
import PartialLoginEnterAccessCodeScreen from '../../ui/screens/PartialLoginEnterAccessCodeScreen';
import PaymentModeSelectionScreen from '../../ui/screens/PaymentModeSelectionScreen';
import PreStartChargingSelectionScreen from '../../ui/screens/PreStartChargingSelectionScreen';
import ProfileScreen from '../../ui/screens/ProfileScreen';
import SearchingScreen from '../../ui/screens/SearchingScreen';
import SearchScreen from '../../ui/screens/SearchScreen';

const MainStackNavigator = createStackNavigator();

export const MainStack = () => {
  // const initialRoute = getGlobalVar(GLOBAL_VARS.initialRoute)?.replace('/', '');

  return (
    <MainStackNavigator.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        cardStyle: {
          backgroundColor: THEME_COLORS.bgColor,
        },
      }}
      // initialRouteName={initialRoute || SCREEN_NAMES.SearchingScreen}>
      initialRouteName={SCREEN_NAMES.SearchingScreen}>

      <MainStackNavigator.Screen name={SCREEN_NAMES.SearchingScreen} component={SearchingScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingStationDetailScreen} component={ChargingStationDetailScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.PreStartChargingSelectionScreen} component={PreStartChargingSelectionScreen}/>

      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargePointQRScannerScreen} component={ChargePointQRScannerScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.SearchScreen} component={SearchScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.EnterFleetCodeScreen} component={EnterFleetCodeScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.EnterAccessCodeScreen} component={EnterAccessCodeScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.PartialLoginEnterAccessCodeScreen} component={PartialLoginEnterAccessCodeScreen} />

      <MainStackNavigator.Screen name={SCREEN_NAMES.MapScreen} component={MapScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.EnterChargePointIdScreen} component={EnterChargePointIdScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.FiltersScreen} component={FiltersScreen} />

      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingStartingSoonScreen} component={ChargingStartingSoonScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingStatesScreen} component={ChargingStatesScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingProcessScreen} component={ChargingProcessScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingSuccessfulScreen} component={ChargingSuccessfulScreen} />

      <MainStackNavigator.Screen name={SCREEN_NAMES.ProfileScreen} component={ProfileScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.EditProfileScreen} component={EditProfileScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingHistoryScreen} component={ChargingHistoryScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.ChargingHistoryFiltersScreen} component={ChargingHistoryFiltersScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.SavedChargingStationsScreen} component={SavedChargingStationsScreen} />
      <MainStackNavigator.Screen name={SCREEN_NAMES.PaymentModeSelectionScreen} component={PaymentModeSelectionScreen} />
    </MainStackNavigator.Navigator>
  );
};
